<template>
    <app-tooltip :value="tooltip" :disabled="!tooltip">
        <v-simple-checkbox
            class="app-table__checkbox"
            color="primaryText"
            :disabled="disabled"
            :value="attr.isSelected"
            :ripple="false"
            @click="onSelect"
        />
    </app-tooltip>
</template>

<script>
export default {
    name: 'ItemDataTableSelect',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        attr: {
            type: Object,
            default: () => ({
                isSelected: false,
                select: () => {}
            })
        },
        selectable: {
            type: [Boolean, Number, Function],
            default: false
        },
        max: {
            type: Number,
            default: null
        }
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isSelectable() {
            if (typeof this.selectable === 'function') {
                return this.selectable(this.attr.item);
            }

            if (Number.isInteger(this.selectable) && this.selectable !== 0) {
                return true;
            }

            return this.selectable === true;
        },
        isMaxed() {
            if (this.max && this.max > 1) {
                return !this.attr.isSelected && this.selected.length >= this.max;
            }

            return false;
        },
        disabled() {
            return !this.isSelectable || this.isMaxed;
        },
        tooltip() {
            if (this.isMaxed) {
                return this.$t('max_items_selected');
            }

            return null;
        }
    },
    methods: {
        onSelect() {
            if (this.disabled) {
                return;
            }

            return this.attr.select(!this.attr.isSelected);
        }
    }
};
</script>
